export const API_ERROR_CODE_I18N_REASON_AUTH_SHARED: Record<string, string> = {
  activity_member_inactive: "common.errors.apiCodeReasons.authShared.activityMemberInactive",
  activity_role_required: "common.errors.apiCodeReasons.authShared.activityRoleRequired",
  admin_access_required: "common.errors.apiCodeReasons.authShared.adminAccessRequired",
  app_session_required: "common.errors.apiCodeReasons.authShared.appSessionRequired",
  application_access_denied: "common.errors.apiCodeReasons.authShared.applicationAccessDenied",
  application_context_invalid: "common.errors.apiCodeReasons.authShared.applicationContextInvalid",
  authorization_prompt_invalid:
    "common.errors.apiCodeReasons.authShared.authorizationPromptInvalid",
  avatar_must_be_image: "common.errors.apiCodeReasons.authShared.avatarMustBeImage",
  candidate_account_expired: "common.errors.apiCodeReasons.authShared.candidateAccountExpired",
  invalid_auth_mode: "common.errors.apiCodeReasons.authShared.invalidAuthMode",
  invalid_return_path: "common.errors.apiCodeReasons.authShared.invalidReturnPath",
  invalid_sso_bff_response: "common.errors.apiCodeReasons.authShared.invalidSsoBffResponse",
  member_access_required: "common.errors.apiCodeReasons.authShared.memberAccessRequired",
  member_inactive: "common.errors.apiCodeReasons.authShared.memberInactive",
  missing_refresh_token: "common.errors.apiCodeReasons.authShared.missingRefreshToken",
  oidc_request_failed: "common.errors.apiCodeReasons.authShared.oidcRequestFailed",
  oidc_transaction_missing: "common.errors.apiCodeReasons.authShared.oidcTransactionMissing",
  redirect_uri_not_configured: "common.errors.apiCodeReasons.authShared.redirectUriNotConfigured",
  session_invalidated: "common.errors.apiCodeReasons.authShared.sessionInvalidated",
  site_maintenance: "common.errors.apiCodeReasons.authShared.siteMaintenance",
  sso_bff_not_configured: "common.errors.apiCodeReasons.authShared.ssoBffNotConfigured",
  sso_bootstrap_failed: "common.errors.apiCodeReasons.authShared.ssoBootstrapFailed",
  teacher_access_required: "common.errors.apiCodeReasons.authShared.teacherAccessRequired",
  user_inactive_or_not_found: "common.errors.apiCodeReasons.authShared.userInactiveOrNotFound",
};
